import CalendarIcon from "../../assets/svgs/calendar.svg";
import styles from "./TaskHeaderAdmin.module.css";

const TaskHeaderAdmin = ({ userName, selectedDate, isMobile }) => {
  return (
    <div className={`${styles.headerWrapper} ${isMobile ? styles.taskHeaderAdminMobile : ""}`}>
      <div className={styles.headerContainer}>
        <img
          src={CalendarIcon}
          alt="Calendario"
          className={styles.calendarIcon}
        />
        <h2 className={isMobile ? styles.mobileUserName : styles.headerTitle}>
          {isMobile ? userName : <>Calendario de <span className={styles.userName}>{userName}</span></>}
        </h2>
      </div>
    </div>
  );
};

export default TaskHeaderAdmin;
